export function loyaltyPurchase(state) {
  return state.loyaltyPurchase;
}
